<div class="input-container">
  <label for="crupdate_group_domain_id" [class.hidden]="hideLabel" trans>Domain</label>
  <select id="crupdate_group_domain_id" [formControl]="formControl">
    <option [ngValue]="null" trans>All my domains (including default)</option>
    <ng-container *ngIf="defaultHost$ | async as defaultHost">
      <option [ngValue]="0">{{ defaultHost }}</option>
      <ng-container *ngFor="let domain of domains">
        <option [ngValue]="domain.id" *ngIf="defaultHost !== domain.host">
          {{ domain.host }}
        </option>
      </ng-container>
    </ng-container>
  </select>
</div>
